import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locale/fr.json";
import fr_landing_page from "./locale/js/fr.js";
import en_landing_page from "./locale/js/en.js";
import es_landing_page from "./locale/js/es.js";
import en from "./locale/en.json";
import es from "./locale/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: ["fr", "en", "es"],
    interpolation: {
      escapeValue: false,
    },
    resources: {
      fr: {
        translation: { ...fr, ...fr_landing_page },
      },
      en: {
        translation: { ...en, ...en_landing_page },
      },

      es: {
        translation: { ...es, ...es_landing_page },
      },
    },
  });

export default i18n;